import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div data-testid="page-404" className="bg-white">
      <Seo title="Page not found" path="/404" noindex />
      <div className="container-wide py-32 text-center max-w-2xl">
        <div className="overline mb-4">404</div>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-tight">The page you're looking for isn't here.</h1>
        <p className="mt-6 text-[#4B5563]">The link may have moved, or the page may no longer exist. Let's get you back on track.</p>
        <div className="mt-10 flex gap-4 justify-center">
          <Link to="/" className="btn btn-primary">Return home</Link>
          <Link to="/contact" className="btn btn-secondary">Contact us</Link>
        </div>
      </div>
    </div>
  );
}
